//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function deepMerge(target, ...sources)
{
	if (sources.length === 0)
		return target;

	const source = sources.shift();

	if (!Latte.util.object.isObject(target) || !Latte.util.object.isObject(source))
		return deepMerge(target, ...sources);

	for (const key in source)
	{
		if (!source.hasOwnProperty(key))
			continue;

		if (Latte.util.object.isObject(source[key]))
		{
			if (!target[key])
				Object.assign(target, {[key]: source[key]});

			deepMerge(target[key], source[key]);
		}
		else
		{
			Object.assign(target, {[key]: source[key]});
		}
	}

	return deepMerge(target, ...sources);
}

export default {

	name: "hub-overview",

	props: {
		namespace: {required: true, type: String}
	},

	data()
	{
		return {
			isLoading: true,
			charts: {},
			instances: {},
			options: {},
			timeout: 0
		};
	},

	destroyed()
	{
		clearTimeout(this.timeout);
	},

	mounted()
	{
		this.onShouldLoadCharts();
	},

	methods: {

		loadCharts()
		{
			Latte.api.request(`/api/hub/apps/${this.namespace}/analytics/chart`, {cache: "no-cache"})
				.then(r => r.json())
				.then(r => this.onChartsLoaded(r))
				.catch(err => Latte.core.handleError(err, () => this.isLoading = false));
		},

		onChartsLoaded(response)
		{
			this.charts = response.data;

			this.makeChart("installations", this.charts["installations_chart"], {
				maintainAspectRatio: false,
				scales: {
					xAxes: [{display: false}],
					yAxes: [{display: false}]
				}
			});
			this.makeChart("operatingSystems", this.charts["operating_systems_chart"], {
				legend: {
					position: 'right',
					labels: {
						boxWidth: 150,
						fontColor: 'white',
						fontSize: 15,
						padding: 36,
						usePointStyle: true
					}
				},
				maintainAspectRatio: false,
				scales: {
					xAxes: [{display: false}],
					yAxes: [{display: false}]
				}
			});
			this.makeChart("launchesDaily", this.charts["launches_daily"], {
				maintainAspectRatio: false
			});
			this.makeChart("launchesMonthly", this.charts["launches_monthly"], {
				maintainAspectRatio: false
			});

			this.isLoading = false;
		},

		onShouldLoadCharts()
		{
			this.loadCharts();
			this.timeout = setTimeout(() => this.onShouldLoadCharts(), 60000);
		},

		makeChart(ref, chart, options = {})
		{
			chart.data.datasets = chart.data.datasets.map(ds => Object.assign(ds, {
				label: Latte.i18n.translate("hub-apps", ds.label)
			}));

			chart.data.labels = chart.data.labels.map(label => this.makeLabel(label));

			this.options[ref] = Object.assign(chart.options, {type: chart.type});

			if (!this.instances[ref])
			{
				chart.options = deepMerge({}, this.makeTooltipOptions(ref), chart.options, options);
				this.instances[ref] = new self.Chart(this.$refs[ref], chart);
			}
			else
			{
				chart.data.datasets.forEach((dataset, index) =>
				{
					if (typeof this.instances[ref].data.datasets[index] !== "undefined")
					{
						let remove = (this.instances[ref].data.datasets[index].data.length > dataset.data.length ? this.instances[ref].data.datasets[index].data.length - dataset.data.length : 0);

						for (let i = 0; i < remove; i++)
							this.instances[ref].data.datasets[index].data.pop();

						dataset.data.forEach((data, i) => this.instances[ref].data.datasets[index].data[i] = data);
					}
					else
					{
						this.instances[ref].data.datasets.push(dataset);
					}
				});

				this.instances[ref].data.labels = chart.data.labels;
				this.instances[ref].update();
			}
		},

		makeLabel(label)
		{
			if (label.indexOf("|") > -1)
			{
				const parts = label.split("|");
				const type = parts[0];

				switch (type)
				{
					case "unix":
						return this.moment(parts[2] * 1000).format(parts[1]);

					case "unix_ms":
						return this.moment(parts[2]).format(parts[1]);

					default:
						return label;
				}
			}

			return label;
		},

		makeTooltipOptions(ref)
		{
			const $this = this;

			return {
				tooltips: {
					enabled: false,
					custom: model =>
					{
						if (model.opacity === 0)
						{
							Latte.action.dispatch("latte:tooltip:hide");
						}
						else
						{
							const h = Latte.util.dom.createElement;

							function genDataRow(line, colors)
							{
								return h("tr", tr =>
								{
									tr.appendChild(h("td", td => td.appendChild(h("div", div =>
									{
										div.classList.add("column-content", "pr-0");
										div.innerHTML = `<i class="mdi mdi-color" style="background-color: ${colors.backgroundColor};"></i>`;
									}))));

									tr.appendChild(h("td", td => td.appendChild(h("div", div =>
									{
										div.classList.add("column-content");
										div.innerHTML = line;
									}))));
								});
							}

							function genTitleRow(title)
							{
								return h("tr", tr => tr.appendChild(h("th", th =>
								{
									th.setAttribute("colspan", "2");
									th.appendChild(h("div", div =>
									{
										div.classList.add("column-content", "font-weight-bold");
										div.innerText = Latte.i18n.translate("hub-apps", title);
									}));
								})));
							}

							const rect = this.$refs[ref].getBoundingClientRect();
							const table = h("table", table =>
							{
								table.classList.add("table", "table-compact");
								table.style.setProperty("--outline-color-secondary", "47,48,50");

								table.appendChild(h("thead", thead =>
								{
									model.title.forEach(title => thead.appendChild(genTitleRow(title)));
								}));

								table.appendChild(h("tbody", tbody =>
								{
									model.body.map(l => l.lines).forEach((line, i) => tbody.appendChild(genDataRow(line, model.labelColors[i])));
								}));
							});

							Latte.action.dispatch("latte:tooltip", {
								x: Math.floor(rect.left + model.caretX),
								y: Math.floor(rect.top + model.caretY),
								classes: ["p-0"],
								content: table,
								position: "vertical"
							});
						}
					},
					callbacks: {
						label(tooltip, data)
						{
							const dataset = data.datasets[tooltip.datasetIndex];
							let prefix = undefined;

							if ($this.options[ref].type === "doughnut")
								prefix = data.labels[tooltip.index];

							const value = dataset.data[tooltip.index];
							const valueFormatted = Intl !== undefined && Intl.NumberFormat !== undefined ? new Intl.NumberFormat(navigator.language)["format"](value) : value;

							if (($this.options[ref].tooltips.transform || "default") === "percentage")
								return `${prefix || dataset.label}: ${value}%`;
							else
								return `${prefix || dataset.label}: ${valueFormatted}`;
						}
					}
				}
			};
		}

	}

}

